module.exports = __webpack_public_path__ + "img/vide2.45cb31e1.png";